import { NgModule } from '@angular/core';

import { SharedComponent } from './shared.component';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FieldErrorDisplayComponent } from './components/field-error-display/field-error-display.component';
import { LoginV2Component } from './components/login/login-v2/login-v2.component';
import { LoginComponent } from './components/login/login/login.component';
import { DoesNotHaveClaimDirective } from './directives/does-not-have-claim.directive';
import { HasClaimDirective } from './directives/has-claim.directive';

// pipes
import { LanguageboxV2Component } from './components/languagebox-v2/languagebox-v2.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

// services
import { InformationMessageComponent } from './components/information-message/information-message.component';
import { OfflinemodeComponent } from './components/offlinemode/offlinemode.component';
import { PlainModalWithCloseIconComponent } from './components/plain-modal-with-close-icon/plain-modal-with-close-icon.component';
import { RunningSubscriptionListComponent } from './components/running-subscription-list/running-subscription-list.component';
import { StatusTagComponent } from './components/status-tag/status-tag.component';
import { SubscriptionDetailComponent } from './components/subscription-detail/subscription-detail.component';
import { SubscriptionListComponent } from './components/subscription-list/subscription-list.component';

import { BulkActionSelectorComponent } from './components/bulk-action-selector/bulk-action-selector.component';
import { ConfirmButtonComponent } from './components/confirm-button/confirm-button.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { FixedConfirmMessageComponent } from './components/fixed-confirm-message/fixed-confirm-message.component';
import { ViewStateContainerComponent } from './components/view-state-container/view-state-container.component';
import { FormControlOverrideDirective } from './directives/form-control-override/form-control-override.directive';
import { IonicIconDirective } from './directives/ionic-override/ionic-icon/ionic-icon.directive';
import { IonicInputDirective } from './directives/ionic-override/ionic-input/ionic-input.directive';
import { IonicSelectDirective } from './directives/ionic-override/ionic-select/ionic-select.directive';
import { IonicTextareaDirective } from './directives/ionic-override/ionic-textarea/ionic-textarea.directive';
import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter/capitalize-first-letter.pipe';
import { ToEnumKeyPipe } from './pipes/enum-key/enum-key.pipe';
import { FormatInMonthsPipe } from './pipes/format-in-months/format-in-months.pipe';
import { FormatLocalizedDatePipe } from './pipes/format-localized-date/format-localized-date.pipe';
import { ReplaceTextPipe } from './pipes/replace-text/replace-text.pipe';
import { ShortenLongTextPipe } from './pipes/shorten-long-name/shorten-long-text.pipe';
import { FeedbackService } from './services/feedback.service';
import { LoadingService } from './services/loading.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    IonicModule.forRoot(),
  ],
  declarations: [
    ToEnumKeyPipe,
    SharedComponent,
    LoginComponent,
    HasClaimDirective,
    DoesNotHaveClaimDirective,
    FieldErrorDisplayComponent,
    SafeUrlPipe,
    DoesNotHaveClaimDirective,
    LoginV2Component,
    LanguageboxV2Component,
    OfflinemodeComponent,
    StatusTagComponent,
    // Ionic overrides
    IonicInputDirective,
    IonicSelectDirective,
    IonicTextareaDirective,
    IonicIconDirective,
    SubscriptionListComponent,
    RunningSubscriptionListComponent,
    SubscriptionDetailComponent,
    FormatInMonthsPipe,
    PlainModalWithCloseIconComponent,
    InformationMessageComponent,
    FormatLocalizedDatePipe,
    CapitalizeFirstLetterPipe,
    FormControlOverrideDirective,
    DatePickerComponent,
    FixedConfirmMessageComponent,
    ViewStateContainerComponent,
    ConfirmButtonComponent,
    ShortenLongTextPipe,
    ReplaceTextPipe,
    BulkActionSelectorComponent,
  ],
  providers: [FeedbackService, LoadingService],
  exports: [
    ToEnumKeyPipe,
    SharedComponent,
    LanguageboxV2Component,
    LoginComponent,
    LoginV2Component,
    HasClaimDirective,
    DoesNotHaveClaimDirective,
    FieldErrorDisplayComponent,
    SafeUrlPipe,
    OfflinemodeComponent,
    StatusTagComponent,
    // Ionic overrides
    IonicInputDirective,
    IonicSelectDirective,
    IonicTextareaDirective,
    IonicIconDirective,
    SubscriptionListComponent,
    RunningSubscriptionListComponent,
    SubscriptionDetailComponent,
    FormatInMonthsPipe,
    InformationMessageComponent,
    FormatLocalizedDatePipe,
    CapitalizeFirstLetterPipe,
    FormControlOverrideDirective,
    DatePickerComponent,
    FixedConfirmMessageComponent,
    ViewStateContainerComponent,
    ConfirmButtonComponent,
    ShortenLongTextPipe,
    ReplaceTextPipe,
    BulkActionSelectorComponent,
  ],
})
export class SharedModule {}
